<template>
    <div class="dark:bg-surface-800 border p-4 rounded-lg">
        <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">{{ $t('Company Selection') }}</h3>
            <div class="flex gap-2">
                <Button
                    :label="$t('New')"
                    icon="pi pi-plus"
                    size="small"
                    class="p-button-success"
                    @click="$emit('create-new')"
                />
                <Button
                    v-if="selectedCompany"
                    :label="$t('Edit')"
                    icon="pi pi-pencil"
                    size="small"
                    class="p-button-outlined"
                    @click="$emit('edit-company')"
                />
            </div>
        </div>
        
        <div class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">{{ $t('Select Company') }} <span class="text-red-500">*</span></label>
                <Dropdown
                    :modelValue="selectedCompany"
                    @update:modelValue="$emit('update:selectedCompany', $event)"
                    :options="companies"
                    optionLabel="name"
                    :placeholder="$t('Choose a company') + ' *'"
                    class="w-full"
                    showClear
                />
            </div>
            
            <div v-if="selectedCompany" class="bg-surface-50 dark:bg-surface-700 p-3 rounded">
                <h4 class="font-medium mb-2">{{ $t('Selected Company Details') }}</h4>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                    <div><strong>{{ $t('Name') }}:</strong> {{ selectedCompany.name }}</div>
                    <div><strong>{{ $t('Email') }}:</strong> {{ selectedCompany.email || 'N/A' }}</div>
                    <div><strong>{{ $t('Document') }}:</strong> {{ selectedCompany.document_number || 'N/A' }}</div>
                    <div><strong>{{ $t('VAT') }}:</strong> {{ selectedCompany.vat_number || 'N/A' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    companies: {
        type: Array,
        default: () => []
    },
    selectedCompany: {
        type: Object,
        default: null
    }
});

defineEmits(['update:selectedCompany', 'create-new', 'edit-company']);
</script>